import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../interfaces/DialogData';

@Component({
    selector: 'app-inform-dialog',
    templateUrl: './inform-dialog.component.html',
    styleUrls: ['./inform-dialog.component.scss'],
    standalone: false
})
export class InformDialogComponent {
  dialogData: DialogData;

  constructor(
    public dialogRef: MatDialogRef<InformDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: DialogData
  ) {
    this.dialogData = data
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
